import React, { useCallback, useEffect, useRef, useState } from 'react';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import PropTypes from 'prop-types';

import withStyles from 'isomorphic-style-loader/withStyles';
import { compose } from 'redux';
import s from './ContainerScrollFade.scss';

const easeIn = (t, alpha) => t ** alpha;

const getMask = opacity => `linear-gradient(180deg, black, rgba(255, 255, 255, ${opacity})) center bottom/100%
    56px no-repeat,
linear-gradient(180deg, black, black) center top/100% calc(100% - 56px)
    no-repeat`;

const ContainerScrollFade = ({ icon }) => {
  const rootRef = useRef(null);
  const [isScrollBtnVisible, setIsScrollBtnVisible] = useState(false);

  const onScroll = useCallback(() => {
    const scrollElement = rootRef.current?.parentElement;
    if (scrollElement) {
      const { scrollTop, scrollHeight, clientHeight } = scrollElement;

      const opacity = easeIn(scrollTop / (scrollHeight - clientHeight), 20);
      const mask = getMask(opacity);

      scrollElement.style.mask = mask;
      // scrollElement.style.webkitMask = mask;

      if (scrollTop + clientHeight < scrollHeight) {
        setIsScrollBtnVisible(true);
      } else {
        setIsScrollBtnVisible(false);
      }
    }
  }, [rootRef]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    const scrollElement = rootRef.current?.parentElement;

    if (scrollElement) {
      const { offsetHeight, scrollHeight } = scrollElement;
      if (offsetHeight !== scrollHeight) {
        const mask = getMask(0);
        scrollElement.style.mask = mask;
        // scrollElement.style.webkitMaskAttachemnt = mask;
      }

      scrollElement.addEventListener('scroll', onScroll);

      onScroll();

      return () => scrollElement.removeEventListener('scroll', onScroll);
    }
  }, [onScroll]);

  return (
    <>
      <div id="scroll-fade" ref={rootRef} />
      <div
        className={s.scrollBottomIcon}
        id="student-view-scroll-bottom-icon"
        style={{
          opacity: isScrollBtnVisible ? 1 : 0,
          visibility: isScrollBtnVisible ? 'visible' : 'hidden',
        }}
      >
        {icon || <ArrowDownwardIcon />}
      </div>
    </>
  );
};

ContainerScrollFade.propTypes = {
  icon: PropTypes.element,
};

ContainerScrollFade.defaultProps = {
  icon: null,
};

export default compose(withStyles(s))(ContainerScrollFade);
